import React, { useState } from "react";
import Navbar from '../../components/Navbar';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const EducationForm =  () => {
  const ID = Cookies.get("log_id");
  const [course,setCourse] = useState("");
  const [institution,setInstitution] = useState("");
  const [from,setFrom] = useState("");
  const [end,setEnd] = useState("");
  const navigate = useNavigate();
  const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        });
  function UnemployedRegistration2(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('id',ID);
    formdata.append('course',course);
    formdata.append('institution',institution);
    formdata.append('from',from);
    formdata.append('end',end);
    axios.put(`${url.path}/unemployed_regist2/`,formdata)
    .then((res) =>{
      if (res.data.status){
        navigate("/professional_details");
      } 
    })
    .catch((err) => {
      Toast.fire({
        icon:'error',
        title:`${err}`
      })
    });
  }

  return (
    <>
    <Navbar />
    <div className="education-form">
      <form  className="education-form-container" onSubmit={UnemployedRegistration2}>
        <h2>Add Education</h2>
        <label>
          Course
          <input type="text" name="course" placeholder="Enter course name" value={course} onChange={(e) =>setCourse(e.target.value)} />
        </label>
        <label>
          Institution Name
          <input type="text" name="institution" placeholder="Enter institution name" value={institution} onChange={(e) =>setInstitution(e.target.value)} />
        </label>
        <div className="date-inputs">
          <label>
            From
            <input type="date" name="from" required value={from} onChange={(e) =>setFrom(e.target.value)} />
          </label>
          <label>
            To
            <input type="date" name="to" required value={end} onChange={(e) =>setEnd(e.target.value)} />
          </label>
        </div>
        <div className="file-upload-container">
      {/* <label className="custom-file-upload">
        <input type="file" onChange={handleFileChange} />
        
      </label> */}
      {/* <span className="file-name">{file ? file.name : "No file chosen"}</span> */}
    </div>
        {/* <button type="submit" className="btn">Add Education</button> */}
        <br />
       
        <button type="submit" className="continue2-btn"   >
          Continue →
        </button>
      </form>
    </div>
    </>
  );
};

export default EducationForm;
